export default "__VITE_ASSET__BEas1AtH__"